import { html, LitElement } from 'lit';

class IconCheckboxUnChecked extends LitElement {
  static properties = {
    height: {
      type: String,
    },
    width: {
      type: String,
    },
    strokeColor: {
      type: String,
      attribute: 'stroke-color',
    },
  };

  constructor() {
    super();
    this.height = '16';
    this.width = '16';
    this.strokeColor = '#0079dd';
  }

  render() {
    return html`
      <svg display="inline-block" width="${this.width}" height="${this.height}" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect stroke="${this.strokeColor}" x="1" y="1" width="14" height="14" rx="2" strokeWidth="2" />
      </svg>
    `;
  }
}
customElements.define('tenable-icon-checkbox-unchecked', IconCheckboxUnChecked);
